import { TLoadable, createUnloaded, createLoading, createLoadErrored, createLoaded } from "../../../../sg-core";
import { IFormContextAction } from "../actions/formContextActions";
import { itemsToMappedIdList } from "../../utils/item.helpers";

export interface ILocationItem {
    id: number;
    title: string;
}

export const defaultFormContextState: IFormContextState = {
    locations: {},
    locationList: createUnloaded()
};

export interface IFormContextState {
    locations: { [key: string]: ILocationItem };
    locationList: TLoadable<number[]>;
};

export default function ContextReducer(state = defaultFormContextState, action: IFormContextAction) {
    switch (action.type) {

        case "REQUEST_FETCH_FORM_CONTEXT_LOCATIONS_ACTIONS": {
            return {
                ...state,
                locationList: createLoading(),
            };
        }

        case "SUCCESS_FETCH_FORM_CONTEXT_LOCATIONS_ACTIONS": {
            const parsed = itemsToMappedIdList(action.payload.locations)
            return {
                ...state,
                locations: parsed.mapping,
                locationList: createLoaded(parsed.ids),
            };
        }

        case "FAILURE_FETCH_FORM_CONTEXT_LOCATIONS_ACTIONS": {
            return {
                ...state,
                locationList: createLoadErrored(action.payload.error),
            };
        }


        default: {
            return state;
        }
    }
}
